import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/business-formation")({
  head: () => ({
    meta: [
      ...routeMeta("/services/business-formation"),
      { title: "New Business Formation in Florida | CCOB And Company PA" },
      { name: "description", content: "Start your Florida LLC, S-Corp, or partnership the right way — entity selection, EIN, registrations, and accounting setup from a CPA." },
      { property: "og:title", content: "New Business Formation — CCOB And Company PA" },
      { property: "og:description", content: "Entity selection, registration, and accounting setup for new Florida businesses." },
    ],
    links: canonicalLinks("/services/business-formation"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="New Business Formation"
      title="Launch Your Business on Solid Financial Ground"
      subtitle="From entity choice to first invoice — set up correctly the first time."
      hero={img.heroServices}
      image={img.consultation}
      intro="Picking the wrong entity (or skipping registrations) costs new owners thousands in their first two years. We walk you through entity selection, register your business with the right agencies, and stand up the accounting and payroll systems you'll grow into."
      items={[
        { title: "Entity Selection Guidance", desc: "LLC, S-Corp, C-Corp, or partnership — chosen for your tax and liability situation, not by default." },
        { title: "SunBiz Registration", desc: "Florida Division of Corporations filing handled end-to-end." },
        { title: "EIN & Federal Setup", desc: "IRS Employer Identification Number, S-Corp election (Form 2553), and required federal filings." },
        { title: "State Tax Registrations", desc: "Florida sales tax, reemployment tax, and any industry-specific licenses you need." },
        { title: "Accounting System Setup", desc: "QuickBooks Online configured with the right chart of accounts for your industry." },
        { title: "First-Year Tax Planning", desc: "Estimated payments, owner draws vs. payroll, and a roadmap for your first return." },
      ]}
    />
  ),
});
